import ScrollToTop from "./ScrollToTop";

import FirstPage from "./FirstPage";
import SecondPage from "./SecondPage";
import ThirdPage from "./ThirdPage";
import ForthPage from "./ForthPage";
import FifthPage from "./FifthPage";
import ProverNetPage from "./ProverNetPage";
import CasePage from "./CasePage";

import SixthPage from "./SixthPage";
import BackedBy from "./BackedBy";

const Home = () => {
  return (
    <>
      <ScrollToTop />
      <FirstPage />
      <SecondPage />
      <ThirdPage />
      <ForthPage />
      <FifthPage />
      <ProverNetPage />
      <CasePage />
      <BackedBy />
      <SixthPage />
    </>
  );
};
export default Home;
